import { Track } from "../../../interfaces/dtos/track";
import { CommonState } from "../../../redux/common/commonSlice";
import { CommonCanUpdate } from "../../../utils/commonRules";
import { categoryItems, getSearchCategoryShared, getSearchProviderShared, updateSearchParamsForCategoryShared, updateSearchParamsForProviderShared } from "../../shared/sharedHelper";

export const trackParamKeys = {
    provider: 'provider',
    category: 'category'
}

export const statusKeys = {
    active: 'A',
    inactive: 'I'
}

export const statusItems = [
    { key: statusKeys.active, value: 'Active' },
    { key: statusKeys.inactive, value: 'Inactive' }
]

export const getSearchProvider = (searchParams: URLSearchParams) => {
    return getSearchProviderShared(searchParams, trackParamKeys.provider);
}

export const getSearchCategory = (searchParams: URLSearchParams) => {
    return getSearchCategoryShared(searchParams, trackParamKeys.category);
}

export const updateSearchParamsForProvider = (searchParams: URLSearchParams, providerCode: string) => {
    return updateSearchParamsForProviderShared(searchParams, providerCode, trackParamKeys.provider);
}

export const updateSearchParamsForCategory = (searchParams: URLSearchParams, categoryCode: string) => {
    return updateSearchParamsForCategoryShared(searchParams, categoryCode, trackParamKeys.category);
}

export const initialSearchParams = (
    searchParams: URLSearchParams, common: CommonState, setSearchParams: (searchParams: URLSearchParams) => void
) => {
    const searchProvider = getSearchProvider(searchParams);
    const searchCategory = getSearchCategory(searchParams);

    if (!searchProvider || !searchCategory) {
        let newSearchParams = searchParams;
        if (!searchProvider) {
            newSearchParams = updateSearchParamsForProvider(
                searchParams, common.providers.length > 0 ? common.providers[0].code : 'betmakers'
            );
        }
        if (!searchCategory) {
            newSearchParams = updateSearchParamsForCategory(searchParams, categoryItems[0].key);
        }
        setSearchParams(newSearchParams);
    }
}

export const canAlterTrack = (track: Track) => {
    // Use common rules
    return CommonCanUpdate(track.provider, track.categoryCode);
}
